import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import { http } from '../../utils/config';

const initialState = {
    status: null,
    isLoadStatus: false,
    isLoadPrice: false,
    isLoadStock: false,
    isLoadBrand: false,
    isLoadCreateBrand: false,
}
export const statusTikTok = createAsyncThunk(
    'TikTok/statusTikTok',
    async (data) => {
        // console.log(data)
        const response = await http.post(
            `/update-status-tiktok`, data
        );
        // console.log(response)
        return response.data.data;
    }
);
export const updatePrice = createAsyncThunk(
    'TikTok/updatePrice',
    async (data) => {
        // console.log(data)
        const response = await http.post(
            `/update-price-tiktok`, data
        );
        // console.log(response)
        return response.data.data;
    }
);
export const updateStock = createAsyncThunk(
    'TikTok/updateStock',
    async (data) => {
        const response = await http.post(
            `/update-stock-tiktok`, data
        );
        return response.data.data;
    }
);
export const updateBrandTiktok = createAsyncThunk(
    'TikTok/updateBrandTiktok',
    async (data) => {
        const response = await http.post(
            `/update-brand-tiktok`, data
        );
        return response.data;
    }
);
export const createCustomBrandTiktok = createAsyncThunk(
    'TikTok/createCustomBrandTiktok',
    async (data) => {
        const response = await http.post(
            `/create-custom-brand-tiktok`,
            { brand_name: data.brand_name, shop_cipher: data.shop_cipher }
        );
        return response.data;
    }
);

/** Lấy chi tiết sản phẩm TikTok (Get Product 202309) và lý do từ chối khi "Bị đình chỉ". */
export const getProductDetailTiktok = createAsyncThunk(
    'TikTok/getProductDetailTiktok',
    async ({ sku, shop_cipher }) => {
        const params = new URLSearchParams({ sku, shop_cipher: shop_cipher || '' });
        const response = await http.get(`/get-product-detail-tiktok?${params.toString()}`);
        const data = response.data?.data ?? response.data ?? {};
        return typeof data === 'object' ? data : { rejection_reason: '' };
    }
);

const updateStatusTiktok = createSlice({
    name: "updateStatusTiktok",
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(statusTikTok.pending, (state) => {
                state.isLoadStatus = true;
            })
            .addCase(statusTikTok.fulfilled, (state, action) => {
                state.status = action.payload
                state.isLoadStatus = false;
            })
            .addCase(statusTikTok.rejected, (state, action) => {
                state.isLoadStatus = false;
            })
            //updatePrice
            .addCase(updatePrice.pending, (state) => {
                state.isLoadPrice = true;
            })
            .addCase(updatePrice.fulfilled, (state, action) => {
                state.isLoadPrice = false;
            })
            .addCase(updatePrice.rejected, (state, action) => {
                state.isLoadPrice = false;
            })
            //UpdateStock
            .addCase(updateStock.pending, (state) => {
                state.isLoadStock = true;
            })
            .addCase(updateStock.fulfilled, (state) => {
                state.isLoadStock = false;
            })
            .addCase(updateStock.rejected, (state) => {
                state.isLoadStock = false;
            })
            .addCase(updateBrandTiktok.pending, (state) => {
                state.isLoadBrand = true;
            })
            .addCase(updateBrandTiktok.fulfilled, (state) => {
                state.isLoadBrand = false;
            })
            .addCase(updateBrandTiktok.rejected, (state) => {
                state.isLoadBrand = false;
            })
            .addCase(createCustomBrandTiktok.pending, (state) => {
                state.isLoadCreateBrand = true;
            })
            .addCase(createCustomBrandTiktok.fulfilled, (state) => {
                state.isLoadCreateBrand = false;
            })
            .addCase(createCustomBrandTiktok.rejected, (state) => {
                state.isLoadCreateBrand = false;
            });
    },

});

export default updateStatusTiktok.reducer